"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Email = void 0;
const InvalidEmailAddress_1 = __importDefault(require("../../Errors/InvalidEmailAddress"));
class Email {
    constructor(value) {
        this.value = value;
        const [handle, domain, ...excessAtSymbols] = value.split('@');
        if (typeof value !== 'string') {
            throw new InvalidEmailAddress_1.default(`Expected a string, got (${typeof value})`, 400);
        }
        if (value.length < 3) {
            throw new InvalidEmailAddress_1.default(`Email address is too short. Got (${value}).`, 400);
        }
        if (!value.includes('@')) {
            throw new InvalidEmailAddress_1.default(`Got ("${value}").`, 400);
        }
        if (excessAtSymbols && excessAtSymbols.length > 0) {
            throw new InvalidEmailAddress_1.default(`Too many @ symbols. Got ("${value}").`, 400);
        }
        if (!handle) {
            throw new InvalidEmailAddress_1.default(`Got ("${value}").`, 400);
        }
        if (['.', '<'].some((illegalCharacter) => value.startsWith(illegalCharacter))) {
            throw new InvalidEmailAddress_1.default(`Email address cannot start with illegal character. Got ("${value}").`, 400);
        }
        if (value.endsWith('.')) {
            throw new InvalidEmailAddress_1.default(`Email address cannot end with a period. Got ("${value}").`, 400);
        }
        if (['”', '\t', '\n', ' '].some((illegalCharacter) => value.includes(illegalCharacter))) {
            throw new InvalidEmailAddress_1.default(`Got ("${value}").`, 400);
        }
        if (['-'].some((illegalCharacter) => domain.startsWith(illegalCharacter))) {
            throw new InvalidEmailAddress_1.default(`Email domain cannot start with illegal character. Got ("${value}").`, 400);
        }
        if (!domain.includes('.')) {
            throw new InvalidEmailAddress_1.default(`Invalid email domain. Got ("${value}").`, 400);
        }
        const splitOnConsecutiveDomainDots = domain.split('.');
        if (splitOnConsecutiveDomainDots.some((part) => !part || part === '')) {
            throw new InvalidEmailAddress_1.default(`Invalid email domain. Got ("${value}").`, 400);
        }
        try {
            new URL(`https://${domain}`);
        }
        catch (err) {
            throw new InvalidEmailAddress_1.default(`Invalid email domain. Got ("${value}").`, 400);
        }
    }
    static create(value) {
        return new this(value);
    }
    equals(otherEmail) {
        if (this.value === otherEmail.value) {
            return true;
        }
        return false;
    }
    get hostName() {
        return this.value.split('@')[1];
    }
    toString() {
        return this.value;
    }
    toJSON() {
        return this.toString();
    }
}
exports.Email = Email;
exports.default = Email;
